import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./components/website/Login";
import Dashbaord from "./components/setup/Dashbaord";
import ProtectedRoute from "./components/setup/ProtectedRoute";
// Admin Management
import Tills from "./components/AdminManagement/Tills";
import DailyOpening from "./components/AdminManagement/DailyOpening";
import DailyClosing from "./components/AdminManagement/DailyClosing";
import SetUserRights from "./components/AdminManagement/SetUserRIghts";
import CreateUser from "./components/AdminManagement/CreateUser";
import SingleDataScreen from "./components/AdminManagement/SingleDataScreen";
import RecipeListing from "./components/AdminManagement/RecipeListing";
import Recipe from "./components/AdminManagement/Recipe";
import ProductionFormulas from "./components/AdminManagement/ProductionFormulas";
import ProductionBatches from "./components/AdminManagement/ProductionBatches";
import StockLedger from "./components/AdminManagement/StockLedger";
import ManualIssuance from "./components/AdminManagement/ManualIssuance";
import Branches from "./components/AdminManagement/Branches/BranchesListing";
import AddNewBranch from "./components/AdminManagement/Branches/AddNewBranch";
import AuditList from "./components/AdminManagement/Audit/AuditListing";
import Audit from "./components/AdminManagement/Audit/Audit";
import OpeningStockEntry from "./components/AdminManagement/Audit/OpeningStockEntry";
import PrinterAssignment from "./components/setup/PrinterAssignment";
import KitchenManagement from "./components/setup/KitchenManagement";
import CategoryKitchenMapping from "./components/setup/CategoryKitchenMapping";
import DispatchCounterManagement from "./components/setup/DispatchCounterManagement";
import TakeawayCounterManagement from "./components/setup/TakeawayCounterManagement";
import DineInTableManagement from "./components/setup/DineInTableManagement";
import DineInTokenManagement from "./components/setup/DineInTokenManagement";
import CashCountersManagement from "./components/setup/CashCountersManagement";
import DealsManagement from "./components/setup/DealsManagement";
import PromoCodesManagement from "./components/setup/PromoCodesManagement";
import PrintBehaviorSettings from "./components/setup/PrintBehaviorSettings";
import CustomerAppThemeSettings from "./components/setup/CustomerAppThemeSettings";
import AccountsManagement from "./components/setup/AccountsManagement";

// General Management Components
import PartiesInformation from "./components/GeneralManagement/PartiesInformation";
import ItemCategory from "./components/GeneralManagement/ItemCategory";
import ItemHeads from "./components/GeneralManagement/ItemHeads";
import ItemCom from "./components/GeneralManagement/ItemCompany";

// Stock Management Components
import ItemsInformation from "./components/StockManagement/ItemsInformation";
import CounterSale from "./components/StockManagement/CounterSale";
// import RestSales from "./components/StockManagement/RestSales";
import PurchaseRequestList from "./components/StockManagement/Purchases/PurchaseRequestList";
import AddPurchaseRequest from "./components/StockManagement/Purchases/AddPurchaseRequest";
import PurchaseOrderList from "./components/StockManagement/Purchases/PurchaseOrderList";
import AddPurchaseOrder from "./components/StockManagement/Purchases/AddPurchaseOrder";
import PurchaseDeliveryList from "./components/StockManagement/Purchases/PurchaseDeliveryList";
import AddPurchaseDelivery from "./components/StockManagement/Purchases/AddPurchaseDelivery";
import POS from './components/StockManagement/POS'
import DeliveryDashboard from './components/StockManagement/DeliveryDashboard'
import ItemsQuickUpdate from './components/StockManagement/ItemsQuickUpdate'
import OrderCancellation from './components/StockManagement/OrderCancellation'

// Stock Reports Components
import SalesDashbaord from "./components/StockReports/SalesDashboard";
import SalesReport from "./components/StockReports/SalesReport";
import SalesByTypeReport from "./components/StockReports/SalesByTypeReport";
import ItemWiseSalesReport from "./components/StockReports/ItemWiseSalesReport";
import ItemChangesAuditReport from "./components/StockReports/ItemChangesAuditReport";
import KOTPrintLogReport from "./components/StockReports/KOTPrintLogReport";
import ClosingReport from "./components/AccountsReports/ClosingReport";
import RestartServices from "./components/AdminManagement/RestartServices";
import CurrentStock from "./components/StockReports/CurrentStock";
import WaitlistAnnouncementMonitor from "./components/setup/WaitlistAnnouncementMonitor";

const theme = createTheme({
  palette: {
    primary: {
      main: '#780202'
    },
    secondary: {
      main: '#ffffff',
    },
    custom: {
      main: "#ffffff"
    }
  },
  typography: {
    fontFamily: [
      // 'Noto Nastaliq Urdu',
      // 'Arial',
      'Helvetica'
    ].join(','),
  },
})

function App() {
  const user = useSelector((state) => state.auth.user);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <WaitlistAnnouncementMonitor />
        <Routes>

          {/* <Route exact path="/" element={<FeedbackForm />} /> */}


          <Route path="/Login" element={<Login />} />

          {/* Account Reports */}
          <Route path="/ClosingReport" element={<ProtectedRoute><ClosingReport /></ProtectedRoute>} />

          {/* Admin Management */}
          <Route path="/Tills" element={<ProtectedRoute><Tills /></ProtectedRoute>} />
          <Route path="/DailyOpening" element={<ProtectedRoute><DailyOpening /></ProtectedRoute>} />
          <Route path="/SetUserRights" element={<ProtectedRoute><SetUserRights /></ProtectedRoute>} />
          <Route path="/CreateUser" element={<ProtectedRoute><CreateUser /></ProtectedRoute>} />
          <Route path="/DailyClosing" element={<ProtectedRoute><DailyClosing /></ProtectedRoute>} />
          <Route path="/RestartServices" element={<ProtectedRoute><RestartServices /></ProtectedRoute>} />
          <Route path="/Recipe" element={<ProtectedRoute><RecipeListing /></ProtectedRoute>} />
          <Route path="/AddRecipe" element={<ProtectedRoute><Recipe /></ProtectedRoute>} />
          <Route path="/ProductionFormulas" element={<ProtectedRoute><ProductionFormulas /></ProtectedRoute>} />
          <Route path="/ProductionBatches" element={<ProtectedRoute><ProductionBatches /></ProtectedRoute>} />
          <Route path="/StockLedger" element={<ProtectedRoute><StockLedger /></ProtectedRoute>} />
          <Route path="/ManualIssuance" element={<ProtectedRoute><ManualIssuance /></ProtectedRoute>} />
          <Route path="/AuditListing" element={<ProtectedRoute><AuditList /></ProtectedRoute>} />
          <Route path="/InvAudit" element={<ProtectedRoute><Audit /></ProtectedRoute>} />
          <Route path="/AuditOpeningStock" element={<ProtectedRoute><OpeningStockEntry /></ProtectedRoute>} />
          <Route path="/Branches" element={<ProtectedRoute><Branches /></ProtectedRoute>} />
          <Route path="/AddBranch" element={<ProtectedRoute><AddNewBranch /></ProtectedRoute>} />
          <Route path="/PrinterAssignment" element={<ProtectedRoute><PrinterAssignment /></ProtectedRoute>} />
          <Route path="/Kitchens" element={<ProtectedRoute><KitchenManagement /></ProtectedRoute>} />
          <Route path="/CategoryKitchenMapping" element={<ProtectedRoute><CategoryKitchenMapping /></ProtectedRoute>} />
          <Route path="/DispatchCounters" element={<ProtectedRoute><DispatchCounterManagement /></ProtectedRoute>} />
          <Route path="/TakeawayCounters" element={<ProtectedRoute><TakeawayCounterManagement /></ProtectedRoute>} />
          <Route path="/DineInTables" element={<ProtectedRoute><DineInTableManagement /></ProtectedRoute>} />
          <Route path="/DineInTokens" element={<ProtectedRoute><DineInTokenManagement /></ProtectedRoute>} />
          <Route path="/CashCounters" element={<ProtectedRoute><CashCountersManagement /></ProtectedRoute>} />
          <Route path="/Deals" element={<ProtectedRoute><DealsManagement /></ProtectedRoute>} />
          <Route path="/PromoCodes" element={<ProtectedRoute><PromoCodesManagement /></ProtectedRoute>} />
          <Route path="/PrintBehaviorSettings" element={<ProtectedRoute><PrintBehaviorSettings /></ProtectedRoute>} />
          <Route path="/CustomerAppTheme" element={<ProtectedRoute><CustomerAppThemeSettings /></ProtectedRoute>} />
          <Route path="/Accounts" element={<ProtectedRoute><AccountsManagement /></ProtectedRoute>} />

          {/* General Management Routes */}
          <Route exact path="/" element={<Navigate to="/POS" replace />} />
          <Route path="/PartiesInformation" element={<ProtectedRoute><PartiesInformation /></ProtectedRoute>} />
          <Route path="/ItemCategory" element={<ProtectedRoute><ItemCategory /></ProtectedRoute>} />
          <Route path="/ItemHeads" element={<ProtectedRoute><ItemHeads /></ProtectedRoute>} />
          <Route path="/itemCompany" element={<ProtectedRoute><ItemCom /></ProtectedRoute>} />
          <Route path="/UnitofMeasurement" element={<ProtectedRoute><SingleDataScreen /></ProtectedRoute>} />
          <Route path="/Departments" element={<ProtectedRoute><SingleDataScreen /></ProtectedRoute>} />

          {/* Stock Management Routes */}
          <Route path="/ItemsInformation" element={<ProtectedRoute><ItemsInformation /></ProtectedRoute>} />
          <Route path="/ItemsQuickUpdate" element={<ProtectedRoute><ItemsQuickUpdate /></ProtectedRoute>} />
          <Route path="/CounterSale" element={<ProtectedRoute><CounterSale /></ProtectedRoute>} />
          {/* <Route path="/Sales" element={<RestSales />} /> */}
          <Route path="/PurchaseRequest" element={<ProtectedRoute><PurchaseRequestList /></ProtectedRoute>} />
          <Route path="/AddPurchaseRequest" element={<ProtectedRoute><AddPurchaseRequest /></ProtectedRoute>} />
          <Route path="/PurchaseOrder" element={<ProtectedRoute><PurchaseOrderList /></ProtectedRoute>} />
          <Route path="/AddPurchaseOrder" element={<ProtectedRoute><AddPurchaseOrder /></ProtectedRoute>} />
          <Route path="/GRN" element={<ProtectedRoute><PurchaseDeliveryList /></ProtectedRoute>} />
          <Route path="/AddGRN" element={<ProtectedRoute><AddPurchaseDelivery /></ProtectedRoute>} />
          <Route path="/POS" element={<ProtectedRoute><POS /></ProtectedRoute>} />
          <Route path="/OrderCancellation" element={<ProtectedRoute><OrderCancellation /></ProtectedRoute>} />
          <Route path="/DeliveryDashboard" element={<ProtectedRoute><DeliveryDashboard /></ProtectedRoute>} />


          {/* Stock Reports */}
          <Route path="/SalesDashbaord" element={<ProtectedRoute><SalesDashbaord /></ProtectedRoute>} />
          <Route path="/SalesReport" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
          <Route path="/SalesByType" element={<ProtectedRoute><SalesByTypeReport /></ProtectedRoute>} />
          <Route path="/ItemWiseSalesReport" element={<ProtectedRoute><ItemWiseSalesReport /></ProtectedRoute>} />
          <Route path="/CurrentStock" element={<ProtectedRoute><CurrentStock /></ProtectedRoute>} />
          <Route path="/ItemChangesAudit" element={<ProtectedRoute><ItemChangesAuditReport /></ProtectedRoute>} />
          <Route path="/KOTPrintLogReport" element={<ProtectedRoute><KOTPrintLogReport /></ProtectedRoute>} />

          {/* <Route path="/ResAppbar" element={<ResAppBar />} /> */}
          <Route path="/DashBaord" element={<ProtectedRoute><Dashbaord /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to={user ? "/POS" : "/Login"} replace />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>

  );
}

export default App;
